import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showDeleteModal: false,
  showAddDepartmentModal: false,
  clearSelection: false,
  selectedDepartment: "",
  isEdit: false,
  itemData: "",
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = departmentSlice.actions;

export default departmentSlice.reducer;
